module.exports = __webpack_public_path__ + "static/qh_13.1998289b.jpg";